import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ImpactingWarningComponent } from "@viewer/impacting-warning/impacting-warning.component";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [CommonModule, MatIconModule, TranslateModule],
  declarations: [ImpactingWarningComponent],
  exports: [ImpactingWarningComponent]
})
export class impactingWarningModule {}
